import React, { Component } from 'react';
import { Card, Footer, MultiSelectView, CreditDetails } from '../common';
import {
  Textarea,
  Heading,
  SubHeading,
  RadioGroup,
  CheckboxList,
  UploadImage,
  Modal,
  Loader,
  NestedRadio,
} from '../../../../../UiKit';
import {
  getFormData,
  checkIfOptional,
  getMultiSelectData,
} from '../../../../commons/CommonMethods';
import { TagsDetails } from '../../../../popups';
import { tagsModel } from '../../../../../api';
import ActionOptions from '../../ActionOptions/ActionOptions';
import MultiSelectViewV2 from '../common/MultiSelectView/MultiSelectV2';
import SuccessScreen from '../../ActionOptions/SuccessScreen';
import { EmptyState } from '../../../../commons';
import { InvalidSearchImg } from '../../../../../images/images';
import { InfoLine } from 'sushiweb/Icons';
import { orange } from 'sushiweb/tokens/color';
import '../../../../../UiKit/checkboxList/checkboxList.scss';
import Spinner from 'sushiweb/Spinner/Spinner';
import { OrderLevelSelect } from './OrderLevelSelect';
import { resoAssistEvaluate } from './reso-assist/resoassist.evaluate';
import { coreEvaluate } from './evaluate/evaluate';
import ResoAssistScreen from './reso-assist/UI/ResoAssistScreen';
import { coreResolve } from './resolve/resolve';

export default class OrderSpilled extends Component {
  constructor(props) {
    super(props);
    const { issueInfo } = this.props;
    this.state = {
      comment: '',
      isEnabled:
        (issueInfo.submit_button && issueInfo.submit_button.is_enabled) ||
        false,
      isFormSubmit: false,
      isError: false,
      isLoading: false,
      errorMessage: '',
      formSubmitRes: null,
      showOptionalError: false,
      selectedRadioOption: null,
      selectedCheckboxOption: null,
      selectedMultiRangeOptions: null,
      selectedSubItemList: null,
      optionalErrorText: '',
      stickyTitle: '',
      inputData: null,
      showRadio: false,
      showCreditOptionsTemp: false,
      creditsBodyParams: null,
      nestedRadio: null,
      selectedNestedRadioOption: null,
      nestedCheckbox: null,
      selectnestedCheckboxOption: null,
      uploadedImages: [],
      tags: null,
      uploadImageError: false,
      showNext: false,
      showResolutionOptions: false,
      resolutionOptionDetails: {},
      orderLevelCharges: [],
      showSuccessScreen: false,
      resolutionSuccessDetails: {},
      buddyRidderAssigned: {},
      showResoAssistScreen: false,
      resoAssistDetails: {},
    };
    this.timerId1 = null;
    this.timerId2 = null;
    this.timerId3 = null;
    this.timerId4 = null;
    this.timerId5 = null;
    this.timerId6 = null;
  }

  componentWillUnmount = () => {
    clearTimeout(this.timerId1);
    clearTimeout(this.timerId2);
    clearTimeout(this.timerId3);
    clearTimeout(this.timerId4);
    clearTimeout(this.timerId5);
    clearTimeout(this.timerId6);
  };

  addComment = (event) => {
    this.setState({
      comment: event.target.value,
      showOptionalError: false,
    });
  };

  sendFormData = (urlStr, params) => {
    const {
      comment,
      inputData,
      selectedRadioOption,
      creditsBodyParams,
      nestedRadio,
      checkBox,
      selectedCheckboxOption,
      selectedNestedRadioOption,
      nestedCheckbox,
      selectnestedCheckboxOption,
      selectedMultiRangeOptions,
      uploadedImages,
    } = this.state;
    const { issueInfo, orderId, reasonId, sendFormData, creditOptions } =
      this.props;
    const { submit_button, comment_box, radio, multi_select_range } = issueInfo;
    let data = {},
      url = urlStr ? urlStr : submit_button.url,
      nestedRadioData,
      nestedCheckboxData,
      multiSelectData,
      radioData,
      checkboxData;

    if (comment_box && !checkIfOptional(comment_box, comment)) {
      this.setState({
        showOptionalError: true,
        optionalErrorText: 'This field is mandatory',
      });
      return;
    }

    if (
      creditOptions &&
      creditOptions.image_uploader &&
      !creditOptions.image_uploader.optional &&
      uploadedImages &&
      !uploadedImages.length
    ) {
      this.setState({
        uploadImageError: true,
      });
      return;
    }

    const commentsData = getFormData(comment_box, comment);
    multiSelectData = getMultiSelectData(
      multi_select_range,
      selectedMultiRangeOptions,
    );

    if (radio) {
      radioData = getFormData(radio, selectedRadioOption);
    }
    if (nestedRadio && nestedRadio.source) {
      nestedRadioData = getFormData(nestedRadio, selectedNestedRadioOption);
    }
    if (nestedCheckbox && nestedCheckbox.source) {
      nestedCheckboxData = getFormData(
        nestedCheckbox,
        selectnestedCheckboxOption,
      );
    }
    if (checkBox) {
      checkboxData = getFormData(checkBox, selectedCheckboxOption);
    }

    Object.assign(
      data,
      commentsData,
      radioData,
      inputData,
      params,
      creditsBodyParams,
      nestedRadioData,
      checkboxData,
      nestedCheckboxData,
      multiSelectData,
    );
    data['order_id'] = orderId;
    // data['images'] = uploadedImages;
    sendFormData(url, reasonId, data);
  };

  // Reso Assist evaluate
  resoAssistEvaluate = (
    callingResponse,
    showLoader,
    isCallStatusUpdated = false,
  ) => {
    const {
      orderId,
      cartId,
      userId,
      complaintType,
      issueInfo,
      handleComplaintImgvisibilty,
    } = this.props;
    const {
      selectedMultiRangeOptions = {},
      orderLevelCharges,
      selectedSubItemList,
    } = this.state;

    resoAssistEvaluate({
      orderId,
      cartId,
      userId,
      complaintType,
      issueInfo,
      selectedMultiRangeOptions,
      orderLevelCharges,
      selectedSubItemList,
      handleComplaintImgvisibilty,
      UpdateNextScreen: this.setState.bind(this),
      callingResponse,
      showLoader,
      isCallStatusUpdated,
    });
  };

  // evaluate complaint function
  evaluate = (
    isDsrResolveFlowActivatedProp = false,
    isViaResoAssistFlow = false,
  ) => {
    const {
      orderId,
      cartId,
      userId,
      complaintType,
      handleComplaintImgvisibilty,
      issueInfo,
    } = this.props;

    const {
      selectedMultiRangeOptions = {},
      orderLevelCharges,
      selectedSubItemList,
    } = this.state;

    coreEvaluate({
      orderId,
      cartId,
      userId,
      complaintType,
      issueInfo,
      selectedMultiRangeOptions,
      orderLevelCharges,
      selectedSubItemList,
      handleComplaintImgvisibilty,
      UpdateNextScreen: this.setState.bind(this),
      isDsrResolveFlowActivatedProp,
      isViaResoAssistFlow,
    });
  };

  // resolve complaint function
  resolve = (resolutionOption, isApproveComplaintFlow = false) => {
    const { orderId, cartId, complaintType, approvedMedia, issueInfo, userId } =
      this.props;
    const {
      selectedMultiRangeOptions = {},
      resolutionOptionDetails,
      selectedSubItemList,
      orderLevelCharges,
    } = this.state;

    coreResolve({
      orderId,
      cartId,
      complaintType,
      approvedMedia,
      issueInfo,
      userId,
      selectedMultiRangeOptions,
      resolutionOptionDetails,
      selectedSubItemList,
      orderLevelCharges,
      isApproveComplaintFlow,
      resolutionOption,
      UpdateNextScreen: this.setState.bind(this),
    });
  };

  selectMultiRangeItems = (items) => {
    const { isResolutionService } = this.props;
    const { selectedSubItemList } = this.state;
    this.setState({
      showRadio: false,
    });
    if (Object.keys(items).length !== 0) {
      this.timerId1 = setTimeout(() => {
        this.setState({
          selectedMultiRangeOptions: items,
          showRadio: !isResolutionService,
          selectedRadioOption: null,
          showCreditOptionsTemp: false,
          creditsBodyParams: null,
          uploadedImages: [],
          showNext: true,
        });
      }, 50);
      return null;
    }
    this.setState({
      selectedMultiRangeOptions: null,
      showRadio: false,
      selectedRadioOption: null,
      showCreditOptionsTemp: false,
      creditsBodyParams: null,
      uploadedImages: [],
      showNext: selectedSubItemList?.length ? true : false,
    });
  };

  selectMultiRangeItemsV2 = (items) => {
    const { handleImageEnable, issueInfo } = this.props;
    const { selectedSubItemList } = this.state;
    if (Object.keys(items).length !== 0) {
      handleImageEnable(true);

      // Check if all selected items with serial_numbers have enough cards picked
      const sourceItems = issueInfo?.multi_select_range?.source || [];
      const sourceById = new Map(sourceItems.map((s) => [s.id, s]));
      const hasUnselectedCards = Object.values(items).some((selectedItem) => {
        const sourceItem = sourceById.get(selectedItem.item_id);
        return (
          sourceItem?.serial_numbers?.length > 0 &&
          (!selectedItem.selected_serial_numbers ||
            selectedItem.selected_serial_numbers.length !== selectedItem.quantity)
        );
      });

      this.timerId1 = setTimeout(() => {
        this.setState({
          selectedMultiRangeOptions: items,
          showNext: !hasUnselectedCards,
        });
      }, 50);
      return null;
    } else {
      handleImageEnable(false);
    }
    this.setState({
      selectedMultiRangeOptions: null,
      showNext: selectedSubItemList?.length ? true : false,
    });
  };

  selectSubItems = (subItems, parentItemId) => {
    this.setState((prevState) => {
      const otherParentsSubItems = (
        prevState.selectedSubItemList || []
      ).filter((subItem) => subItem?.parent_item_id !== parentItemId);
      const dedupedSubItems = Array.from(
        (subItems || []).reduce(
          (map, item) => map.set(item?.item_id, item),
          new Map(),
        ),
        ([, item]) => item,
      );
      const mergedSubItemList = [...otherParentsSubItems, ...dedupedSubItems];
      return {
        selectedSubItemList: mergedSubItemList,
        showNext:
          prevState.selectedMultiRangeOptions || mergedSubItemList?.length,
      };
    });
  };

  getCreditOptions = () => {
    const { issueInfo, reasonId, orderId, getCreditOptions } = this.props;
    const {
      nestedRadio,
      nestedCheckbox,
      selectedMultiRangeOptions,
      selectedRadioOption,
      selectedNestedRadioOption,
      selectnestedCheckboxOption,
      checkBox,
      selectedCheckboxOption,
    } = this.state;
    let data = {},
      multiSelectRange = issueInfo && issueInfo.multi_select_range,
      nestedRadioData,
      nestedCheckboxData,
      checkboxData;
    const multiSelectData = getMultiSelectData(
      multiSelectRange,
      selectedMultiRangeOptions,
    );
    const radioData = getFormData(issueInfo.radio, selectedRadioOption);
    if (nestedRadio && nestedRadio.source) {
      nestedRadioData = getFormData(nestedRadio, selectedNestedRadioOption);
    }

    if (nestedCheckbox && nestedCheckbox.source) {
      nestedCheckboxData = getFormData(
        nestedCheckbox,
        selectnestedCheckboxOption,
      );
    }

    if (checkBox) {
      checkboxData = getFormData(checkBox, selectedCheckboxOption);
    }

    Object.assign(
      data,
      multiSelectData,
      radioData,
      nestedRadioData,
      nestedCheckboxData,
      checkboxData,
    );
    this.setState({
      creditsBodyParams: data,
      showCreditOptionsTemp: true,
    });
    data['order_id'] = orderId;
    getCreditOptions(issueInfo.radio.url, reasonId, data);
  };

  selectOption = (radio, selectedRadioOption, item) => {
    this.setState({
      nestedRadio: null,
      nestedCheckbox: null,
      selectedNestedRadioOption: null,
      selectnestedCheckboxOption: null,
    });
    this.timerId2 = setTimeout(() => {
      this.setState({
        selectedRadioOption: selectedRadioOption,
        showCreditOptionsTemp: false,
        uploadedImages: [],
        nestedRadio: item.radio ? item.radio : null,
        nestedCheckbox: item.check_box ? item.check_box : null,
        showCheckbox: false,
      });
    }, 0);
    if (!item.radio && !item.check_box) {
      this.timerId3 = setTimeout(() => {
        this.getCreditOptions();
      }, 100);
    }
  };

  selectNestedRadioOption = (selectedRadioOption, item) => {
    this.setState({
      nestedCheckbox: null,
      selectnestedCheckboxOption: null,
    });
    this.timerId4 = setTimeout(() => {
      this.setState({
        selectedNestedRadioOption: selectedRadioOption,
        uploadedImages: [],
        showCreditOptionsTemp: false,
        nestedCheckbox: item.check_box ? item.check_box : null,
      });
    }, 0);
    if (item.check_box) return;
    this.timerId5 = setTimeout(() => {
      this.getCreditOptions();
    }, 100);
  };

  selectnestedCheckboxOption = (selectedOption) => {
    let optionsCount = Array.isArray(selectedOption) && selectedOption.length;
    this.setState({
      selectnestedCheckboxOption: selectedOption,
      showCreditOptionsTemp: false,
      uploadedImages: [],
    });
    if (!optionsCount) return;
    this.timerId6 = setTimeout(() => {
      this.getCreditOptions();
    }, 100);
  };

  showCreditOptions = () => {
    const { orderId, reasonId, creditOptions, isDisabled, handleCardLink } =
      this.props;
    if (!creditOptions) return null;
    return (
      <CreditDetails
        creditOptions={creditOptions}
        sendFormData={this.sendFormData}
        orderId={orderId}
        reasonId={reasonId}
        isDisabled={isDisabled}
        handleCardLink={handleCardLink}
      />
    );
  };

  fileUpload = (images) => {
    this.setState({
      uploadedImages: images,
      uploadImageError: false,
    });
  };

  closePopup = () => {
    this.setState({
      showTagsPopup: false,
    });
  };

  showTags = (show_ticket_only) => {
    const { orderId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    queryStrings['show_ticket_only'] = show_ticket_only;
    tagsModel
      .getTags(queryStrings)
      .then((response) => {
        if (!response || (response && response.isError === true)) return null;
        this.setState({
          tags: response,
          showTagsPopup: true,
        });
      })
      .catch(() => {
        console.log('Tags Details error');
      });
  };

  handleOrderSelectOption = (orderLevelOptions) => {
    this.setState({
      orderLevelCharges: orderLevelOptions,
    });
  };

  handleBuddyRiderAssignment = (item) => {
    this.setState({
      selectedRadioOption: item?.value,
      nestedRadio: item.radio ? item.radio : null,
    });
  };

  infoComp = (showInfoLine = true) => (
    <div className='tw-w-full tw-flex tw-flex-col '>
      <div className='tw-mx-6'>
        <OrderLevelSelect
          handleOrderSelectOption={this.handleOrderSelectOption}
          orderLevelCharges={this.state.orderLevelCharges}
          OrderLevelSelectDetails={this.props.issueInfo?.order_level_select}
        />
      </div>
      {showInfoLine && (
        <div className='tw-flex tw-w-full tw-gap-4 tw-mx-6 '>
          <InfoLine size={16} color={orange.z500} />
          <span className='tw-text-orange-500 tw-text-200 tw-font-medium'>
            Please upload complaint image(s).
          </span>
        </div>
      )}
    </div>
  );

  render() {
    const {
      issueInfo,
      creditOptions,
      isDisabled,
      orderId,
      cartId,
      userId,
      reasonId,
      complaintType,
      isResolutionService,
      goBack,
      mandateImageCheck,
      handleComplaintImgvisibilty,
      availableComplaintImages = [],
      isMediaRefetching,
      mediaValidation,
    } = this.props;
    const {
      showOptionalError,
      optionalErrorText,
      stickyTitle,
      showRadio,
      showCreditOptionsTemp,
      nestedRadio,
      nestedCheckbox,
      uploadedImages,
      showTagsPopup,
      tags,
      uploadImageError,
      showNext,
      showResolutionOptions,
      resolutionOptionDetails,
      showSuccessScreen,
      resolutionSuccessDetails,
      isLoading,
      isError,
      errorMessage,
      showResoAssistScreen,
      resoAssistDetails,
    } = this.state;

    if (!issueInfo) return null;

    const { is_dsr_flow, show_reso_assist_flow: showResoAssistFlow } =
      issueInfo || {};

    if (isLoading) return <Loader />;

    if (isError)
      return <EmptyState img={InvalidSearchImg} heading={errorMessage} />;

    const isNotOrderItemsSelectionFlow =
      (isResolutionService || is_dsr_flow) &&
      (showSuccessScreen || showResolutionOptions);

    return (
      <div className='raiseIssueContainer'>
        {showResoAssistScreen ? (
          <ResoAssistScreen
            coreEvaluate={this.evaluate}
            resoAssistEvaluate={this.resoAssistEvaluate}
            resoAssistDetails={resoAssistDetails}
            setShowResolutionOptions={() => {
              this.setState({
                showResolutionOptions: false,
                showResoAssistScreen: false,
              });
            }}
            handleComplaintImgvisibilty={handleComplaintImgvisibilty}
            orderId={orderId}
            cartId={cartId}
            userId={userId}
            complaintType={complaintType}
          />
        ) : isNotOrderItemsSelectionFlow ? (
          showSuccessScreen ? (
            <SuccessScreen details={resolutionSuccessDetails} goBack={goBack} />
          ) : (
            // Resolution Options (Refund, Replacement) Radio Group
            <div
              className={`raiseIssueContent ${
                is_dsr_flow ? '' : '!tw-bg-[#F3F4F6]'
              }`}
            >
              <ActionOptions
                orderId={orderId}
                cartId={cartId}
                userId={userId}
                setShowResolutionOptions={() => {
                  this.setState({
                    showResolutionOptions: false,
                    showResoAssistScreen: false,
                  });
                }}
                resolutionOptionDetails={resolutionOptionDetails}
                resolve={
                  is_dsr_flow
                    ? () => {
                        this.evaluate(true);
                      }
                    : this.resolve
                }
                disabled={isLoading}
                handleComplaintImgvisibilty={handleComplaintImgvisibilty}
                availableComplaintImages={availableComplaintImages}
                complaintType={complaintType}
                isDSRFlow={is_dsr_flow}
              />
            </div>
          )
        ) : (
          // Order Items selection screen
          <>
            <div className='raiseIssueContent'>
              {issueInfo.title && <Heading title={issueInfo.title.text} />}

              {issueInfo.subtitle && (
                <SubHeading title={issueInfo.subtitle.text} />
              )}

              {issueInfo?.display_map && issueInfo?.display_map?.length ? (
                <div className='tw-w-full tw-flex tw-flex-col tw-gap-2 tw-mb-3'>
                  {issueInfo?.display_map.map((item, index) => {
                    return (
                      <div key={`${item.key}_${index}`}>
                        <span className='tw-text-300 tw-font-medium'>
                          {`${item.key}:`}&nbsp;
                        </span>
                        <span className='tw-text-200'>{item.value}</span>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              {issueInfo.card && (
                <div className='pt10 pb20'>
                  <Card
                    content={issueInfo.card}
                    onClick={this.showTags.bind(
                      this,
                      issueInfo.card.show_ticket_only,
                    )}
                  />
                </div>
              )}

              {issueInfo.multi_select_range &&
                issueInfo.multi_select_range.source.length && (
                  <React.Fragment>
                    {issueInfo.multi_select_range.title && (
                      <Heading
                        title={issueInfo.multi_select_range.title.text}
                      />
                    )}

                    {isResolutionService || is_dsr_flow ? (
                      <MultiSelectViewV2
                        items={issueInfo.multi_select_range.source}
                        selectItems={this.selectMultiRangeItemsV2}
                        selectedItem={this.state.selectedMultiRangeOptions}
                        selectSubItems={this.selectSubItems}
                        handleNextBtn={(val) => {
                          this.setState({
                            showNext: val,
                          });
                        }}
                        selectedSubItemList={this.state.selectedSubItemList}
                        cartId={cartId}
                        userId={userId}
                        orderId={orderId}
                        complaintType={complaintType}
                      />
                    ) : (
                      <MultiSelectView
                        items={issueInfo.multi_select_range.source}
                        selectItems={this.selectMultiRangeItems}
                        isResolutionService={isResolutionService}
                      />
                    )}

                    {(isResolutionService || is_dsr_flow) &&
                    showNext &&
                    !showResoAssistScreen ? (
                      <div>
                        <Footer
                          submitBtnTitle={'Next'}
                          btnBgColor='#0C831F'
                          sendFormData={
                            showResoAssistFlow
                              ? this.resoAssistEvaluate
                              : this.evaluate
                          }
                          isDisabled={
                            isLoading || (showNext && !mandateImageCheck)
                          }
                          info={
                            isMediaRefetching ? (
                              <div className='tw-w-full tw-items-center tw-justify-center'>
                                <Spinner color='#0C831F' />
                              </div>
                            ) : !mandateImageCheck ? (
                              this.infoComp()
                            ) : mediaValidation === 'NOT_APPLICABLE' ? (
                              this.infoComp(false)
                            ) : (
                              this.infoComp()
                            )
                          }
                        />
                      </div>
                    ) : null}
                    {showRadio && issueInfo.radio && (
                      <React.Fragment>
                        {issueInfo.radio.title && (
                          <Heading title={issueInfo.radio.title.text} />
                        )}
                        <RadioGroup
                          items={issueInfo.radio.source}
                          selectOption={this.selectOption.bind(
                            this,
                            issueInfo.radio,
                          )}
                        />
                        {nestedRadio && (
                          <React.Fragment>
                            {nestedRadio.title && (
                              <Heading title={nestedRadio.title.text} />
                            )}
                            {nestedRadio.subtitle && (
                              <SubHeading title={nestedRadio.subtitle.text} />
                            )}
                            <RadioGroup
                              items={nestedRadio.source}
                              selectOption={this.selectNestedRadioOption.bind(
                                this,
                              )}
                            />
                          </React.Fragment>
                        )}
                        {nestedCheckbox && (
                          <React.Fragment>
                            {nestedCheckbox.title && (
                              <Heading title={nestedCheckbox.title.text} />
                            )}
                            {nestedCheckbox.subtitle && (
                              <SubHeading
                                title={nestedCheckbox.subtitle.text}
                              />
                            )}
                            <CheckboxList
                              items={nestedCheckbox.source}
                              selectOptions={this.selectnestedCheckboxOption.bind(
                                this,
                              )}
                            />
                          </React.Fragment>
                        )}
                        {showCreditOptionsTemp && creditOptions ? (
                          <React.Fragment>
                            {creditOptions.image_uploader && (
                              <UploadImage
                                fileUpload={this.fileUpload}
                                uploadedImages={uploadedImages}
                                orderId={orderId}
                                reasonId={reasonId}
                                imageUploader={creditOptions.image_uploader}
                                url={creditOptions.image_uploader.url}
                                uploadImageError={uploadImageError}
                              />
                            )}
                            {this.showCreditOptions()}
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}

              {issueInfo.comment_box && (
                <div className='pt10'>
                  <Textarea
                    showBtn={false}
                    placeholder={issueInfo.comment_box.placeholder}
                    height='15vh'
                    onChange={this.addComment}
                    error={showOptionalError}
                    errorText={optionalErrorText}
                  />
                </div>
              )}

              {Boolean(issueInfo?.radio?.source?.length) && (
                <React.Fragment>
                  <div>
                    {issueInfo.radio.title && (
                      <Heading title={issueInfo.radio.title} />
                    )}
                    <NestedRadio
                      data={issueInfo.radio}
                      items={issueInfo.radio.source}
                      selectOption={this.handleBuddyRiderAssignment}
                    />
                  </div>
                </React.Fragment>
              )}
            </div>

            <Footer
              issueInfo={issueInfo}
              stickyTitle={stickyTitle}
              sendFormData={this.sendFormData}
              isDisabled={isDisabled}
            />

            {showTagsPopup && (
              <Modal
                isVisible={showTagsPopup}
                type='large'
                title='Tags Log'
                handleClose={this.closePopup.bind(this)}
                component={<TagsDetails tags={tags} />}
              />
            )}
          </>
        )}
      </div>
    );
  }
}
